var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "drag_indicator_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-3, .cls-4 {\n        fill: currentColor;\n      }\n\n      .cls-3 {\n        opacity: 0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17845",
    "data-name": "Path 17845",
    className: "cls-3",
    d: "M0,0H20V20H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17846",
    "data-name": "Path 17846",
    className: "cls-4",
    d: "M14.667,7.333A1.667,1.667,0,1,0,13,5.667,1.672,1.672,0,0,0,14.667,7.333Zm0,1.667a1.667,1.667,0,1,0,1.667,1.667A1.672,1.672,0,0,0,14.667,9Zm0,5a1.667,1.667,0,1,0,1.667,1.667A1.672,1.672,0,0,0,14.667,14Z",
    transform: "translate(-4.667 -0.667)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicator);
export default __webpack_public_path__ + "static/media/drag-indicator.8e60bdbb25725a1c7b836c91766298ba.svg";
export { ForwardRef as ReactComponent };